import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { initAnalytics } from "@/lib/analytics";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import EbookPage from "@/pages/EbookPage";
import PhotoGuide from "@/pages/PhotoGuide";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import LegacyMembers from "@/pages/LegacyMembers";
import Contact from "@/pages/Contact";
import HowItWorks from "@/pages/HowItWorks";
import BlackExcellence from "@/pages/BlackExcellence";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";
import EbookPopup from "@/components/EbookPopup";
import ExitIntent from "@/components/ExitIntent";
import ReferralBanner from "@/components/ReferralBanner";
import { captureRefCode } from "@/lib/referrals";

function RefCapture() {
  const location = useLocation();
  useEffect(() => { captureRefCode(); }, [location.pathname, location.search]);
  return null;
}

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <HelmetProvider>
      <div className="App grain">
      <BrowserRouter>
        <ScrollToTop />
        <RefCapture />
        <ReferralBanner />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/collection/:slug" element={<ProductPage />} />
          <Route path="/ebook" element={<EbookPage />} />
          <Route path="/photo-guide" element={<PhotoGuide />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/black-excellence-unveiled" element={<BlackExcellence />} />
          <Route path="/legal/:slug" element={<LegalPage />} />
          <Route path="/legacy-members" element={<LegacyMembers />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/checkout/cancel" element={<CheckoutCancel />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <EbookPopup />
        <ExitIntent />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#111111",
            color: "#F7F1E7",
            border: "1px solid rgba(212, 175, 55, 0.25)",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
      </div>
    </HelmetProvider>
  );
}

export default App;
